import { FunctionComponent } from 'react'

import Icons from 'atoms/Icons'
import { LinearGradient } from 'expo-linear-gradient'
//import { BottomSheetModal } from 'molecules'
import {
  Text,
  HStack,
  useBreakpointValue,
  Divider,
  // Pressable,
  VStack
  // Box,
  //  Center
} from 'native-base'
import { theme } from 'src/theme'

type ExcellenceProgramScoreCardProps = {
  title: string
  stars: number
  description: {
    title: string
    value: number
  }[]
}

/* const EXCELLENCE_PROGRAM_TABLE = [
  { score: 1, points: '<=3', commission: '0,0%' },
  { score: 2, points: '4 a 5', commission: '0,1%' },
  { score: 3, points: '6 a 7', commission: '0,2%' },
  { score: 4, points: '8', commission: '0,3%' },
  { score: 5, points: '>=9', commission: '0,5%' },
  { points: 'MOL<0', commission: '0' }
] */

export const ExcellenceProgramScoreCard: FunctionComponent<ExcellenceProgramScoreCardProps> = ({
  description,
  title,
  stars
}) => {
  const isMobile = useBreakpointValue({ base: true, lg: false })

  // const bottomSheetRef = useRef<BottomSheetModal>(null)

  return (
    <LinearGradient
      colors={[
        theme.colors['header-gradient'][50],
        theme.colors['header-gradient'][100],
        theme.colors['header-gradient'][200]
      ]}
      style={{
        borderRadius: 20,
        marginBottom: isMobile ? 24 : 32,
        width: isMobile ? undefined : '1122px'
      }}>
      <VStack p={6} space={4}>
        <HStack
          flexDir={{
            base: 'column',
            lg: 'row'
          }}
          justifyContent="space-between"
          alignItems="center">
          <HStack
            alignItems="center"
            flexDir={{ base: 'column', lg: 'row' }}
            mb={{ base: '32px', lg: 0 }}>
            <Text
              fontSize="14px"
              lineHeight="18px"
              color="white"
              fontWeight={700}
              numberOfLines={1}
              mb={{ base: 4, lg: 0 }}
              mr={{ base: 0, lg: 2 }}>
              {title}
            </Text>
            <HStack space={2}>
              <Icons.Star filled size={8} color={stars >= 1 ? 'tabs-yellow.50' : 'gray.600'} />
              <Icons.Star filled size={8} color={stars >= 2 ? 'tabs-yellow.50' : 'gray.600'} />
              <Icons.Star filled size={8} color={stars >= 3 ? 'tabs-yellow.50' : 'gray.600'} />
              <Icons.Star filled size={8} color={stars >= 4 ? 'tabs-yellow.50' : 'gray.600'} />
              <Icons.Star filled size={8} color={stars === 5 ? 'tabs-yellow.50' : 'gray.600'} />
            </HStack>
          </HStack>

          <HStack
            justifyContent="space-between"
            alignItems="center"
            space={{ base: 2, lg: 6 }}
            flexDir={{ base: 'column', lg: 'row' }}>
            {!isMobile && <Divider borderColor="white" h="32px" orientation="vertical" />}
            {description.map((item, index) => (
              <HStack
                alignItems="center"
                space={1}
                key={`${index}-${item?.value}`}
                mb={{ base: 2, lg: 0 }}>
                <Text
                  fontSize="12px"
                  lineHeight="16px"
                  color="white"
                  fontFamily="OpenSans_400Regular"
                  numberOfLines={1}>
                  {item.title}
                </Text>
                <Text
                  fontSize="14px"
                  color="white"
                  fontFamily="OpenSans_700Bold"
                  lineHeight="16px"
                  numberOfLines={1}>
                  {item.value}
                </Text>
              </HStack>
            ))}
          </HStack>
        </HStack>
        {/* @TODO: Remove when SIM V2 is Ready */}

        {/* 
        <HStack
          justifyContent="space-between"
          alignItems="center"
          flexDir={{
            base: 'column',
            lg: 'row'
          }}
          bg="gray.700"
          px={4}
          py={4}
          rounded="md">
          <Text
            mb={{
              base: 2,
              lg: 0
            }}
            color="tabs-yellow.50"
            fontSize="12px"
            lineHeight="16px"
            textAlign={{
              base: 'center',
              lg: 'left'
            }}>
           // Temporary, will come from backend 
            Inelegível ao Programa. Motivo: MOL da Carteira é negativo.
          </Text>
          <HStack>
            <Pressable
              onPress={() => bottomSheetRef.current?.present()}
              flexDirection="row"
              alignItems="center">
              <Text color="gray.300" mr={2} fontWeight="bold">
                Ver tabela completa
              </Text>
              <Icons.Arrow direction="right" color="gray.300" size={4} />
            </Pressable>
            <CustomBottomSheet ref={bottomSheetRef} snapPoints={['75%']}>
              <VStack space={8} p={{ base: 4, lg: 0 }}>
                <HStack space={2} alignItems="center">
                  <Pressable w={10} h={10} onPress={() => bottomSheetRef.current?.close()}>
                    <Center w={10} h={10} bgColor="gray.50" borderRadius={20}>
                      <Icons.Close size={4} color="gray.700" />
                    </Center>
                  </Pressable>
                  <Text
                    fontSize="18px"
                    fontWeight="bold"
                    color="gray.800"
                    maxW={{ base: '280px', lg: 'auto' }}>
                    Classificação Programa de Excelência
                  </Text>
                </HStack>

                <VStack bg="gray.30" rounded="20px" px={2} py={4} space={4} maxW="full">
                  <HStack justifyContent="space-between">
                    <Box w="40%" alignItems="center">
                      <Text fontWeight="bold" color="gray.600">
                        Classificação
                      </Text>
                    </Box>
                    <Box w="30%" alignItems="center">
                      <Text fontWeight="bold" color="gray.600">
                        Pontuação
                      </Text>
                    </Box>
                    <Box w="30%" alignItems="center">
                      <Text fontWeight="bold" color="gray.600">
                        Comissão
                      </Text>
                    </Box>
                  </HStack>

                  <Divider bg="gray.100" />

                  {EXCELLENCE_PROGRAM_TABLE.map((item, index) => (
                    <HStack
                      py={{
                        base: 2,
                        lg: 0
                      }}
                      key={index}
                      justifyContent="space-between"
                      alignItems="center">
                      <Box w="40%" alignItems="center">
                        <HStack space={1} justifyContent="center">
                          {item?.score ? (
                            <>
                              {Array.from({ length: item.score }).map((_, scoreIndex) => (
                                <Box key={scoreIndex} p={1} bg="gray.50" rounded="12px">
                                  <Icons.Star
                                    key={scoreIndex}
                                    size={isMobile ? 4 : 6}
                                    filled
                                    color="tabs-yellow.50"
                                  />
                                </Box>
                              ))}
                            </>
                          ) : (
                            <Text color="gray.600">Não elegível</Text>
                          )}
                        </HStack>
                      </Box>
                      <Box w="30%" alignItems="center">
                        <Text color="gray.600">{item.points}</Text>
                      </Box>
                      <Box w="30%" alignItems="center">
                        <Text color="gray.600">{item.commission}</Text>
                      </Box>
                    </HStack>
                  ))}
                </VStack>
              </VStack>
            </CustomBottomSheet>
          </HStack>
        </HStack>
      */}
      </VStack>
    </LinearGradient>
  )
}
